import { family_member, patent_family, trade_mark, commodity, design_family, design_registration, competitor_member } from "../../data"
import { Family, Member } from "../../patents/patents"
import { familyUrl, memberUrl } from "../../patents/utils"
import { Trademark } from "../../trademarks/TrademarksProvider"
import { trademarkUrl } from "../../trademarks/utils"
import { Commodity, commodityUrl } from "../../products/products"
import { DesignFamily, DesignRegistration } from "../../designs/designs"
import { designFamilyUrl, designRegistrationUrl } from "../../designs/utils"
import { CompetitorMember } from "../../external/external"
import { competitorMemberUrl } from "../../external/utils"
import { ReferenceProps } from "./ReferenceLinker"


export function getReference(
    link: {entity?: string, entityId?: number},
    familyById: Record<number, Family>,
    memberById: Record<number, Member>,
    trademarkById: Record<number, Trademark>,
    commodityById: Record<number, Commodity> = {},
    designFamilyById: Record<number, DesignFamily> = {},
    designRegistrationById: Record<number, DesignRegistration> = {},
    competitorMemberById: Record<number, CompetitorMember> = {}
): ReferenceProps & {to: string} {

    const entity = link.entity
    const entityId = link.entityId
    let internalReference = undefined
    let to = undefined
    if (entity === patent_family && entityId in familyById) {
        const family = familyById[entityId]
        internalReference = family?.internalReference
        to = familyUrl(family)
    } else if (entity === family_member && entityId in memberById) {
        const member = memberById[entityId]
        internalReference = member?.internalReference
        to = memberUrl(member)
    } else if (entity === trade_mark && entityId in trademarkById) {
        const trademark = trademarkById[entityId]
        internalReference = trademark?.reference
        to = trademarkUrl(trademark)
    } else if (entity === commodity && entityId in commodityById) {
        const comm = commodityById[entityId]
        internalReference = comm?.commodityReference
        to = commodityUrl(comm)
    } else if (entity === design_family && entityId in designFamilyById) {
        const df = designFamilyById[entityId]
        internalReference = df?.reference
        to = designFamilyUrl(df)
    } else if (entity === design_registration && entityId in designRegistrationById) {
        const dr = designRegistrationById[entityId]
        internalReference = dr?.reference
        to = designRegistrationUrl(dr)
    } else if (entity === competitor_member && entityId in competitorMemberById) {
        const cm = competitorMemberById[entityId]
        internalReference = cm?.internalReference
        to = competitorMemberUrl(cm)
    }

    return ({
        entity,
        entityId,
        internalReference,
        to,
    })
}

export function isEquivalent(a?: ReferenceProps, b?: ReferenceProps) {
    return a?.entity === b?.entity && a?.entityId === b?.entityId
}